module.exports = __webpack_public_path__ + "static/media/photo-2.09dca651.jpg";